import React from 'react'
import { useParams } from 'react-router-dom'
import ocContent from '../JSONData/ourClients.json'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import BannerImage from '../assets/images/ourclient-banner.jpg'
import BannerImageMobile from '../assets/images/ourclient-banner-mobile.jpg'
import config from '../config';
const Ourclient = ({ clients, bgImage, BgImageMobile }) => {
    const defaultBg = BannerImage;
    const defaultBgMobile = BannerImageMobile;

    const { lang } = useParams();
    const labels = (ocContent && ocContent[lang]) ? ocContent[lang] : ocContent.en;
    return (
        <>
            <div className="our-clients position-relative pt-50 pb-100 d-pt-100 border-top border-gray">
                <picture className="cover overlay position-absolute top-0 start-0">
                    <source
                        media="(max-width:768px)"
                        srcSet={BgImageMobile || defaultBgMobile}
                    />
                    <img
                        className="cover"
                        src={bgImage || defaultBg}
                        alt="client background"
                    />
                    </picture>
                <div className='container position-relative'>
                    <div className='text-block h6 mb-30'>{labels.title}</div>
                </div>
                <div className='client-slider-block'>
                    <Swiper
                        modules={[Autoplay]}
                        slidesPerView={3}
                        spaceBetween={40}
                        loop={true}
                        autoplay={{ delay: 1500, disableOnInteraction: false }}
                        breakpoints={{
                            768: {
                                slidesPerView: 5,
                            },
                            1024: {
                                slidesPerView: 6.2,
                            },
                            1920: {
                                slidesPerView: 7,
                            },
                        }}
                        className="client-swiper px-10"
                    >
                        {clients && clients.map((clientUrl, index) => (
                            <SwiperSlide key={index}>
                                <img
                                    src={`${config.BASE_URL}${clientUrl}`}
                                    alt={`Client logo ${index + 1}`}
                                    className=""
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    )
}

export default Ourclient
